import React from 'react';
import { range } from 'lodash';
import TextPlaceholder from 'components/shared/TextPlaceholder';
import HeaderPlaceholder from './Header';
import ContentPlaceholder from './content';

const JourneyViewerLoader = () => (
  <div className="PathViewerLoader">
    <div className="JourneyViewerLoader-overview">
      <TextPlaceholder maxWidth={15} minWidth={15} />
    </div>
    <HeaderPlaceholder />
    <div className="PathContentsList">
      {range(3).map(i => (
        <ContentPlaceholder key={i} />
      ))}
    </div>
  </div>
);

export default JourneyViewerLoader;
